<template>
  <div class="content">
    <!-- 头部部分 -->
    <el-form :model="queryParams" ref="queryForm"  :inline="true" label-width="68px">
      <el-form-item prop="companyName">
        <el-input v-model="queryParams.companyName" placeholder="公司名称"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item prop="name">
        <el-input v-model="queryParams.name" placeholder="姓名"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item  prop="phone" >
        <el-input v-model="queryParams.phone" placeholder="手机号"  @keyup.enter.native="search" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="search">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
        <el-button type="primary" icon="el-icon-download"  @click="down">导出</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="tableData" border @cell-click="cellClick" @sort-change="tableSortChange" ref="tableData">
      <el-table-column type="index" label="序号" align="center" width="60px"></el-table-column>
      <el-table-column prop="companyName" label="公司名称" align="center" width="300"></el-table-column>
      <el-table-column prop="openId" label="OpenId" align="center" :show-overflow-tooltip="true" ></el-table-column>
      <el-table-column prop="name" label="姓名" sortable="custom" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="phone" label="手机号" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="position" label="职务" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="business" label="主营业务" align="center" :show-overflow-tooltip="true"></el-table-column>
      <el-table-column prop="seat" label="座位" width="300" align="center">
        <template slot-scope="scope">
          <el-input v-if="scope.row.id == tabClickId"  ref="editInput" v-model="scope.row.seat" v-focus
                      size="small" type="text" @blur="inputBlur(scope.row)" placeholder="请输入备注"/>
          <span v-else>
              <span>{{scope.row.seat}}</span><i class="el-icon-edit bianji-class"></i>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="创建时间" align="center" :show-overflow-tooltip="true"></el-table-column>
    </el-table>
    <pagination
        v-show="total>0"
        :total="total"
        :page.sync="page"
        :limit.sync="pageSize"
        @pagination="initData"
    />
  </div>
</template>
<script>
import { userEnterpriseList , updateUserEnterprise } from "@/api/api.js"; //用户列表获取初始化数据
export default {
  name: "userEnterprise",
  directives: {
    // 注册一个局部的自定义指令 v-focus
    focus: {
      // 指令的定义
      inserted(el) {
        el.querySelector('input').focus()
      }
    }
  },
  data() {
    return{
      queryParams:{
        companyName:undefined,
        name:undefined,
        phone:undefined
      },
      sortOrder: "",
      sortName: "",
      tableData:[],
      page: 1,
      pageSize: 20,
      total:0,
      show:false,
      form:{},
      tabClickId: null, 

    }
  },
  methods: {
    // 获取列表的数据
    initData(){
      let params ={
        model:{
          ...this.queryParams,
          order: this.sortOrder,
          sort: this.sortName,
        },
        page: this.page,
        pageSize: this.pageSize,
      }
      userEnterpriseList(params).then(res => {
        this.tableData = res.data.data.records;
        this.total = res.data.data.total;
      })
    },
    tableSortChange(val){
      this.sortOrder = val.order == "descending" ? "desc" : "asc";
      if(val.prop == 'name'){
        this.sortName = 'name'
      }
      if(!val.order){
        this.sortOrder = undefined
        this.sortName = undefined
      }
      this.initData()
    },
    // 搜索
    search() {
      this.page = 1,
      this.initData();
    },
    // 重置
    resetQuery() {
      this.resetForm("queryForm");
      this.sortOrder = '';
      this.sortName = '';
      this.$refs.tableData.clearSort();
      this.search();
    },
    editRow(row){
      this.show = true
      this.form = Object.assign({}, row);
    },
    submit(){
      updateUserEnterprise(this.form).then(res=>{
          this.$notify({
            title: "成功",
            message: "修改成功",
            type: "success"
          });
          this.show= false
          this.search()
      })
    },
    cancel(){
      this.form={}
      this.show = false
    },
    // 失去焦点初始化
    cellClick(row, column, cell, event) {
      this.tabClickId = null
      if (column.property === 'seat') {
        this.tabClickId = row.id
      }
    },
    inputBlur(row) {
      this.tabClickId = null;
      // 保存备注
      let params = {
        id:row.id,
        seat:row.seat == null ? "":row.seat
      }
      updateUserEnterprise(params).then(res=>{
        this.$message.success("修改成功");
      })
    },
    down() {
      this.download('/user/enterprise/import', {
        ...this.queryParams
      }, `enterprise_${new Date().getTime()}.xlsx`)
    },

  },
  created() {
    this.initData();
  },
};
</script>

<style scoped lang="less">

</style>


